import AbstractOperatorApplicationListener
    from "~/operatorApplication/ts/service/comet/AbstractOperatorApplicationListener";
import {OperatorApplicationEventManager} from "~/operatorApplication/ts/OperatorApplicationEventManager";

export default class ClientClickOnLink extends AbstractOperatorApplicationListener {
    public getAction(): string {
        return "clientClickOnLink";
    }

    public async receive(payload: CometOperatorApplication.ClientClickOnLinkCometMessageOpenApiModel) {
        let eventName = ClientClickOnLink.getEventNameByUsername(payload.username);
        OperatorApplicationEventManager.emit(eventName, payload.link);
    }

    public static getEventNameByUsername(username: string): string {
        return `ClientClickOnLink_${username}`;
    }

}